import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Procurement from "./Procurement";
import ProcurementmedicineList from "./ProcurementmedicineList";
import CompSecuAccessControl from "./CompSecuAccessControl";
import Pharmacypurchasetable from "./Pharmacypurchasetable";
import OptionsModal from "./OptionsModal";
import { FaRegEdit } from "react-icons/fa";
import SideFilters from "../pharmacy/Utility/SideFilters";
import { SideSort } from  "../pharmacy/Utility/SideSort";
import { FiSearch, FiFilter, FiChevronDown } from "react-icons/fi";
import { DatePicker, Space } from 'antd';
import ReturnPurchaseTable from "./ReturnPurchaseTable";
import PurchasePaymentTable from "./PurchasePaymentTable";
import {useEffect} from "react";
import PaymentModeModal from "./pharmacymodels/PaymentModeModal";
import PaymentDetailsModal from "./pharmacymodels/PaymentDetailsModal";
import TransactionDetailModal from "./pharmacymodels/TransactionDetailModal";
import AddDistributorModel from "../ClinicModal/AddDistributorModel";
import { useLazyGetAllPurchaseViewQuery } from "../../State/Api/PharmacyOrderApiSlice";
import PaymentViewModal from "./pharmacymodels/PaymentViewModal";
const { RangePicker } = DatePicker;


function PharmacyPurchase({ distributorData }) {

 const [fetchPurchase, { data: purchaseData, isFetching, failed }] = useLazyGetAllPurchaseViewQuery();
  const pharmaId=localStorage.getItem("userUniqueID");
  const distributorId=distributorData?.distributorID

   useEffect(() => {
        if (pharmaId && distributorId) {
          fetchPurchase({pharmaId,distributorId});
        }
      }, [pharmaId,distributorId]);

      const [selectedDistributor, setSelectedDistributor] = useState(null);

useEffect(() => {
  if (distributorData) {
    setSelectedDistributor(distributorData);
  }
}, [distributorData]);

 const [showOptionsModal, setShowOptionsModal] = useState(false);

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('purchase');
  const [activeFilterTab, setActiveFilterTab] = useState('distributor');
const [searchTerm, setSearchTerm] = useState('');
const [hasUnsavedDrafts, setHasUnsavedDrafts] = useState(true);
const [open, setOpen] = useState(false);
const [editDistributorData, setEditDistributorData] = useState(null);
const [isEditMode, setIsEditMode] = useState(false);
const [showUserTypeModal, setShowUserTypeModal] = useState(false);
const [showSimplePaymentModal, setShowSimplePaymentModal] = useState(false);

const [currentStep, setCurrentStep] = useState(0);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [patients, setPatients] = useState([]);
 const [selectedPaymentMode, setSelectedPaymentMode] = useState('');
  const [paymentDetails, setPaymentDetails] = useState({});
  const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
const handleEditDistributor = (dist) => {
  setEditDistributorData(dist || null);
  setIsEditMode(true);
  setOpen(true);              // reuse your Add Distributor modal open state
};

 const handleAddDistributor = () => {
    setOpen(true);
  };
const openPaymentModal = () => {
    setCurrentStep(1);
    setShowPaymentModal(true);
  };
    const closePaymentModal = () => {
    setShowPaymentModal(false);
    setCurrentStep(0);
    setSelectedPaymentMode('');
    setPaymentDetails({});
  };

  const handleStep1Next = (mode) => {
    setSelectedPaymentMode(mode);
    setCurrentStep(2);
  };

  const handleStep2Next = (details) => {
    setPaymentDetails(details);
    setCurrentStep(3);
  };

  const handleStep2Back = () => {
    setCurrentStep(1);
  };

  const handleStep3Back = () => {
    setCurrentStep(2);
  };

   
  const tabs = [
    { id: 'purchase', label: 'PURCHASES (452)', count: 452 },
    { id: 'returns', label: 'RETURNS (2)', count: 2 },
    { id: 'payments', label: 'PAYMENTS (0)', count: 0 },
  ];


  const handlePurchaseOrder = () => navigate("/PurchaseOrder");
  const handleAddBilling = () => navigate("/AddBilling");
  const handlePharmacyPurchasereturn = () => {
  // Navigate to PharmacyPurchasereturn with a flag to open the modal
  navigate("/PharmacyPurchasereturn", { 
    state: { 
      openModal: true 
    } 
  });
};
  


  return (
    <>
      <style>
        {`
        .sidebar-tabs-section {
  background: white;
  border-bottom: 1px solid #f0f0f0;
}

.tabs-header {
  display: flex;
  padding: 0;
  background: white;
  border-bottom: 1px solid #f0f0f0;
}

.tabs-header1 {
  display: flex;
  padding: 0 20px;
  background: white;
  border-bottom: 1px solid #f0f0f0;
}

.tab-btn {
  background: none;
  border: none;
  padding: 16px 0;
  margin-right: 32px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
}

.tab-btn.active {
  color: #333;
  font-weight: 600;
}

.tab-btn.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: #23db95ff;
}

.search-controls-bar {
  display: flex;
  gap: 8px;
  padding: 16px 16px;
  background: white;
  border-bottom: 1px solid #f0f0f0;
}

.search-input-wrapper {
  flex: 1;
  position: relative;
  display: flex;
}

.search-input {
  flex: 1;
  padding: 10px 16px;
  border: 1px solid #ddd;
  border-radius: 6px 0 0 6px;
  font-size: 14px;
  outline: none;
  background: #f9f9f9;
}

.search-input::placeholder {
  color: #999;
}

.search-btn {
  padding: 10px 16px;
  background: white;
  border: 1px solid #ddd;
  border-left: none;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-btn, .sort-btn {
  padding: 10px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
}

.filter-btn:hover, .sort-btn:hover, .search-btn:hover {
  background: #f5f5f5;
}

.unsaved-drafts-banner {
  background: linear-gradient(90deg, #fff3cd 0%, #ffeaa7 100%);
  padding: 12px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.banner-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.view-drafts-btn {
  background: none;
  border: none;
  color: #e74c3c;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.arrow {
  font-size: 12px;
}

.content-list {
  flex: 1;
  overflow-y: auto;
  background: white;
}



.distributor-item:hover {
  background: #f8f9fa;
}

.distributor-item.selected {
  background: #e3f2fd;
  border-left: 3px solid #2196f3;
}



.distributor-details {
  flex: 1;
  min-width: 0;
}

.distributor-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.distributor-meta {
  font-size: 12px;
  color: #666;
}

.distributor-amount {
  text-align: right;
}

.amount {
  font-size: 14px;
  font-weight: 600;
  color: #e74c3c;
  margin-bottom: 2px;
}

.amount-status {
  font-size: 11px;
  color: #666;
}

.empty-state {
  padding: 40px 20px;
  text-align: center;
  color: #666;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .tabs-header {
    padding: 0 15px;
  }
  
  .tab-btn {
    margin-right: 24px;
    font-size: 13px;
  }
  
  .search-controls-bar {
    padding: 12px 15px;
    gap: 6px;
  }
  
  .distributor-item {
    padding: 12px 15px;
  }
}

        .search-filter-container {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.search-bar-wrapper {
  width: 100%;
}

.search-input-container {
  position: relative;
  width: 100%;
}

.search-input {
  width: 100%;
  padding: 8px 40px 8px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  transition: all 0.2s ease;
  outline: none;
}

.search-input:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.1);
}

.search-input::placeholder {
  color: #999;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  pointer-events: none;
}

          .pharmacy-container {
            display: flex;
            height: 100%;
            background: #f5f5f5;
            gap: 0;
          }

          .sidebar-container {
            width: 350px;
            min-width: 300px;
            background: white;
            color: #000;
            display: flex;
            flex-direction: column;
            box-shadow: 2px 0 10px rgba(0,0,0,0.1);
          }

          .sidebar-header {
            padding: 20px;
            border-bottom: 1px solid rgba(255,255,255,0.2);
            background: rgba(255,255,255,0.1);
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .sidebar-title {
            font-size: 18px;
            font-weight: 600;
            margin: 0 0 5px 0;
          }

          .sidebar-subtitle {
            font-size: 12px;
            opacity: 0.8;
            margin: 0;
          }

          .add-distributor-btn {
            background: rgba(255,255,255,0.2);
            color: white;
            border: 1px solid rgba(255,255,255,0.3);
            padding: 8px 12px;
            border-radius: 4px;
            font-size: 12px;
            cursor: pointer;
            transition: all 0.3s ease;
            margin-top: 10px;
          }

          .add-distributor-btn:hover {
            background: rgba(255,255,255,0.3);
            transform: translateY(-1px);
          }

          .distributor-list {
            flex: 1;
            overflow-y: auto;
            padding: 0px 0 10px 0;
          }

         .distributor-item {
  padding: 15px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  background: rgba(255,255,255,0.05);
  margin: 0 0 2px 0;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items:center;
  border-bottom: 1px solid #dbdadaff;
  justify-content:space-between;
}

           .distributor-item:hover {
    background: #f8f9fa;
    border-left-color: #dee2e6;
  }
            .distributor-item.selected {
    background: rgba(204, 252, 212, 0.3);
    border-left-color: #28a745;
    box-shadow: 0 2px 8px rgba(40, 167, 69, 0.15);
  }

          .distributor-item.selected {
            background: rgba(204, 252, 212, 0.2);
            border-left-color: #7ee6a0ff;
          }

          .distributor-code {
            display: inline-block;
            background: rgba(204, 252, 212, 0.2);
            padding: 5px 5px;
            border-radius: 50px;
            font-size: 11px;
            font-weight: bold;
            margin-bottom: 8px;
            color: #49bb7cff;
          }

            .distributor-headercode {
            display: inline-block;
            background: rgba(204, 252, 212, 0.2);
            padding: 8px 8px;
            border-radius: 50%;
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 8px;
            color: #49bb7cff;
          }

          .distributor-name {
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 5px;
            line-height: 1.3;
          }

          .distributor-due {
            font-size: 12px;
            font-weight: 600;
            color: #49bb7cff;
          }

          .distributor-date {
            font-size: 12px;
            font-weight: 600;
            color: #bdbcbaff;
          }

          .main-content {
            flex: 1;
            background: #fff;
            overflow-y: auto;
            position: relative;
            
          }

          .content-header {
            background: white;
            color: black;
            padding: 20px;
          }

          .distributor-info {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
            gap: 20px;
          }

          .distributor-details h2 {
            margin: 0 0 10px 0;
            font-size: 24px;
            font-weight: 600;
          }

          .distributor-meta {
            font-size: 13px;
            line-height: 1.4;
            opacity: 0.9;
          }

          .action-buttons {
            display: flex;
            gap: 10px;
            flex-wrap: wrap;
          }

          .action-btn {
            background: rgba(255,255,255,0.2);
            color: white;
            border: 1px solid rgba(255,255,255,0.3);
            padding: 10px 16px;
            border-radius: 4px;
            font-size: 13px;
            cursor: pointer;
            transition: all 0.3s ease;
            font-weight: 500;
          }

          .action-btn:hover {
            background: rgba(255,255,255,0.3);
            transform: translateY(-1px);
          }

          .stats-container {
            background: #fff;
            margin: 20px;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            overflow: hidden;
          }

          .stats-header {
            background: #f8f9fa;
            padding: 15px 20px;
            border-bottom: 1px solid #dee2e6;
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            gap: 15px;
            font-size: 11px;
            font-weight: 600;
            color: #6c757d;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .stats-values {
            padding: 15px 20px;
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            gap: 15px;
            font-size: 13px;
            font-weight: 500;
            color: #28a745;
          }

          .tabs-container {
            background: #fff;
            margin: 0 20px;
            border-radius: 8px 8px 0 0;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }

          .tabs-header {
            display: flex;
            border-bottom: 1px solid #dee2e6;
          }

          .tab-button {
            padding: 15px 20px;
            background: none;
            border: none;
            font-size: 13px;
            font-weight: 600;
            color: #6c757d;
            cursor: pointer;
            transition: all 0.2s ease;
            border-bottom: 2px solid transparent;
          }

          .tab-button.active {
            color: #38bb64ff ;
            border-bottom-color: #29b959ff;
            background: rgba(204, 252, 212, 0.2);
          }

          .tab-content {
            padding: 10px;
            min-height: 400px;
          }

          .empty-state {
            text-align: center;
            padding: 60px 20px;
            color: #6c757d;
          }

          .empty-state h3 {
            font-size: 18px;
            margin-bottom: 10px;
            color: #495057;
          }

          .empty-state p {
            font-size: 14px;
            opacity: 0.8;
          }
            .transaction-date {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  min-width: 80px;
}

.transaction-details {
  flex: 1;
  text-align: center;
}

.transaction-amount {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
}

.transaction-count {
  font-size: 12px;
  color: #666;
}

.transaction-status {
  min-width: 30px;
  text-align: center;
}

.status-indicator {
  font-size: 16px;
  color: #999;
  font-weight: 500;
}

          /* Responsive Design */
          @media (max-width: 1200px) {
            .stats-header,
            .stats-values {
              grid-template-columns: repeat(3, 1fr);
              gap: 10px;
            }

            .stats-header {
              font-size: 10px;
            }

            .stats-values {
              font-size: 12px;
            }
          }

          @media (max-width: 768px) {
            .pharmacy-container {
              flex-direction: column;
              height: auto;
            }

            .sidebar-container {
              width: 100%;
              min-width: auto;
              max-height: 40vh;
            }

            .distributor-info {
              flex-direction: column;
              gap: 15px;
            }

            .action-buttons {
              width: 100%;
              justify-content: stretch;
            }

            .action-btn {
              flex: 1;
              text-align: center;
            }

            .stats-header,
            .stats-values {
              grid-template-columns: repeat(2, 1fr);
              gap: 8px;
            }

            .stats-header {
              font-size: 9px;
            }

            .stats-values {
              font-size: 11px;
            }

            .tabs-header {
              flex-wrap: wrap;
            }

            .tab-button {
              flex: 1;
              min-width: 0;
              padding: 12px 10px;
              font-size: 12px;
            }
          }

          @media (max-width: 480px) {
            .content-header {
              padding: 15px;
            }

            .distributor-details h2 {
              font-size: 20px;
            }

            .stats-container,
            .tabs-container {
              margin: 10px;
            }

            .stats-header,
            .stats-values {
              grid-template-columns: 1fr;
              text-align: center;
            }
          }
        `}
      </style>

      <div className="pharmacy-container">


        {/* Main Content */}
        <div className="main-content">
          {selectedDistributor ? (
            <>
             {/* Header with distributor info */}
<div className="content-header p-6 bg-white rounded-2xl shadow-md border border-gray-100">
  {/* Top Row: Circle + Name + Button */}
  <div className="flex items-center justify-between mb-4">
    <div className="flex items-center gap-4">
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-green-100 text-green-700 font-bold text-2xl shadow-sm">
        {selectedDistributor?.distributorName?.[0]?.toUpperCase()}
      </div>
      <h2 className="text-2xl font-bold text-gray-800">
        {selectedDistributor?.distributorName}
      </h2>
    </div>

    <button
      className="gradient-button px-4 py-2 rounded-lg text-white font-semibold"
      onClick={() => setShowSimplePaymentModal(true)}
    >
      + Add Payment
    </button>
  </div>

  {/* Distributor Info Grid */}
<div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-2 text-sm text-gray-700 leading-relaxed pl-8">
    <p><span className="font-medium text-gray-800">Contact:</span> {selectedDistributor?.contact}</p>
    <p><span className="font-medium text-gray-800">Address:</span> {selectedDistributor?.fullAddress}</p>
    <p><span className="font-medium text-gray-800">GST No:</span> {selectedDistributor?.gstNo}</p>
    <p><span className="font-medium text-gray-800">Drug Lic:</span> {selectedDistributor?.drugLicense}</p>
    <p className="col-span-2">
  <span className="font-medium text-gray-800">Last Txn:</span>{" "}
  {selectedDistributor?.lastTxnDate
    ? new Date(selectedDistributor.lastTxnDate)
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .replace(/ /g, "-") // "12 Nov 2025" → "12-Nov-2025"
    : "-"}
</p>

  </div>

  {/* More Options */}
  <div
    className="mt-6 inline-flex items-center gap-2 text-green-600 hover:text-green-700 cursor-pointer transition-all border-t border-gray-100 pt-3"
    onClick={() => setShowOptionsModal(true)}
  >
    <FaRegEdit className="text-base" />
    <span className="font-medium text-[15px]">More Options</span>
  </div>

  {/* Modal */}
  <OptionsModal
    show={showOptionsModal}
    onHide={() => setShowOptionsModal(false)}
    distributor={selectedDistributor}
    onEdit={handleEditDistributor}
  />
  <AddDistributorModel
  isOpen={open}                      
  onClose={() => {
    setOpen(false);
    setIsEditMode(false);
    setEditDistributorData(null);
  }}
  editData={editDistributorData}     
/>


  <PaymentModeModal
  show={showPaymentModal && currentStep === 1}
  onHide={closePaymentModal}
  onNext={handleStep1Next}
  currentStep={currentStep}
/>

<PaymentDetailsModal
  show={showPaymentModal && currentStep === 2}
  onHide={closePaymentModal}
  onNext={handleStep2Next}
  onBack={handleStep2Back}
  selectedMode={selectedPaymentMode}
  currentStep={currentStep}
/>

<TransactionDetailModal
  show={showPaymentModal && currentStep === 3}
  onHide={closePaymentModal}
  onSave={(finalData) => {
    console.log("Final Payment Data:", {
      paymentMode: selectedPaymentMode,
      ...finalData,
    });
    setToastMessage("Payment transaction saved successfully!");
    setShowToast(true);
    closePaymentModal();
  }}
  onBack={handleStep3Back}
  paymentData={paymentDetails}
  currentStep={currentStep}
/>
<PaymentViewModal
  show={showSimplePaymentModal}
  onHide={() => setShowSimplePaymentModal(false)}
  distributorName={selectedDistributor?.distributorName}
/>

</div>



              {/* Stats Container */}
              <div className="stats-container">
                <div className="stats-header">
                  <div>TOTAL PURCHASE</div>
                  <div>PURCHASE DUE</div>
                  <div>TOTAL RETURNS</div>
                  <div>RETURN DUE</div>
                  <div>BALANCE</div>
                  <div>CREDIT PERIOD</div>
                </div>
                <div className="stats-values">
                  <div>₹{selectedDistributor?.totalPurchase}</div>
                  <div>₹{selectedDistributor?.purchaseDue}</div>
                  <div>₹{selectedDistributor?.totalReturns}</div>
                  <div>₹{selectedDistributor?.returnDue}</div>
                  <div>₹{selectedDistributor?.balance}</div>
                  <div>{selectedDistributor?.creditPeriod}</div>
                </div>
              </div>

              {/* Tabs Container */}
              <div className="tabs-container">
                <div className="tabs-header">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
                <div className="tab-content">
                  {activeTab === 'purchase' && <Pharmacypurchasetable purchaseData={purchaseData?.purchaseBills}/>}
                  {activeTab === 'returns' && <ReturnPurchaseTable />}
                  {activeTab === 'payments' && <PurchasePaymentTable />}
                </div>
              </div>
            </>
          ) : (
            <div className="empty-state">
              <h3>Select a Distributor</h3>
              <p>Please select a distributor from the left panel to view purchase details.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default PharmacyPurchase;
